import { Helmet } from "react-helmet-async";
import { PasswordResetForm } from "@/components/auth/password-reset-form";
import PageTitle from "@/components/ui/page-title";

const PasswordResetPage = () => {
  return (
    <>
      <Helmet>
        <title>Recuperar Senha - MoovaTV</title>
        <meta name="description" content="Recupere sua senha do MoovaTV." />
      </Helmet>

      <div className="flex flex-col items-center justify-center min-h-screen py-12">
        <PageTitle className="mb-8">Recuperar Senha do</PageTitle>
        <PasswordResetForm />
      </div>
    </>
  );
};

export default PasswordResetPage;
